const PLATFORMS = ['ios', 'android', 'desktop', 'web', 'portal']

// The desktop app (Electron) exposes window.electronPush from the preload script
export const getHelpPlatform = (override) => {
  if (PLATFORMS.includes(override)) return override
  return typeof window !== 'undefined' && window.electronPush ? 'desktop' : 'web'
}
